export const BRAND_NAME = 'OA LOSAS'
export const WHATSAPP_NUMBER = '5214777557721'
export const PHONE_DISPLAY = '477 755 7721'
export const PHONE_TEL = '+524777557721'

export const FREE_DELIVERY_THRESHOLD = 5000

export const GTM_ID = 'GTM-XXXXXXX' // Reemplazar por el ID real de Google Tag Manager
export const META_PIXEL_ID = '000000000000' // Reemplazar por el ID real del Pixel de Meta

export const PERKS = [
  { id: 'entrega', title: 'Entrega sin costo desde $5,000', short: 'Envío gratis desde $5,000', text: 'A domicilio o directo en tu obra.' },
  { id: 'factura', title: 'Facturación', short: 'Facturamos', text: 'Pide tu factura al cotizar.' },
  { id: 'medida', title: 'Pedidos personalizados', short: 'Altura y largo a medida', text: 'En altura y largo, a la medida de tu proyecto.' },
] as const

export const DELIVERY_CITIES = [
  'León',
  'Querétaro',
  'Celaya',
  'Irapuato',
  'Salamanca',
  'Silao',
  'Guanajuato',
  'Aguascalientes',
  'San Miguel de Allende',
]

export const PROBLEM_POINTS = [
  'No sabes qué peralte elegir.',
  'Te cotizan sin flete y luego te sorprenden.',
  'Nadie te confirma disponibilidad.',
  'No sabes cuántas piezas necesitas.',
  'Pierdes días esperando respuesta.',
]

export interface DoorOption {
  id: string
  title: string
  text: string
  message: string
}

export const DOOR_OPTIONS: DoorOption[] = [
  {
    id: 'precio-rapido',
    title: 'Necesito precio rápido',
    text: 'Ya sabes medida y cantidad. Escríbenos y te cotizamos al momento.',
    message:
      'Hola OA LOSAS, ya sé qué necesito y quiero precio.\n\nMaterial y medida:\nCantidad:\nCiudad de entrega:',
  },
  {
    id: 'calcular-piezas',
    title: 'No sé cuántas piezas necesito',
    text: 'Pásanos los m² de tu losa y te calculamos piezas sin costo.',
    message:
      'Hola OA LOSAS, necesito ayuda para calcular piezas.\n\nm² aproximados de losa:\nTipo de losa (vigueta y bovedilla / reticular):\nCiudad de entrega:',
  },
  {
    id: 'volumen',
    title: 'Soy constructor o distribuidor',
    text: 'Precio especial por volumen y compra recurrente.',
    message:
      'Hola OA LOSAS, soy constructor/distribuidor y quiero precio por volumen.\n\nEmpresa:\nMateriales de interés:\nVolumen aproximado:\nCiudad:',
  },
]

export const BENEFITS = [
  { title: 'Ligero y fácil de maniobrar', text: 'Una persona carga una pieza de 3 m sin equipo.' },
  { title: 'Menos peso muerto en losa', text: 'Menos carga sobre estructura y cimentación.' },
  { title: 'Sistema completo', text: 'Bovedilla, casetón y vigueta en un solo pedido.' },
  { title: 'Pieza larga de 300 cm', text: 'Menos cortes y colocación más rápida.' },
  { title: 'A tu medida', text: 'Pedidos personalizados en altura y largo.' },
  { title: 'Entrega sin costo desde $5,000', text: 'Directo en tu obra, sin sorpresas de flete.' },
]

export const QUOTE_CHECKLIST = [
  'Material y medida',
  'Piezas o m² de losa',
  'Ciudad de entrega',
  'Fecha aproximada',
  'Si necesitas factura',
  'Recoges o entrega en obra',
]

export const FAQS = [
  {
    q: '¿Qué medidas manejan?',
    a: 'Bovedilla EPS 63 x 300 cm en 12, 13, 15, 19 y 24 cm de peralte; casetón EPS en 40 x 40, 60 x 40 y 60 x 60 cm con distintos peraltes; y semi-vigueta y vigueta pretensada.',
  },
  {
    q: '¿Hacen medidas personalizadas?',
    a: 'Sí. Hacemos pedidos personalizados en altura y largo. Indícanos la medida exacta al cotizar.',
  },
  {
    q: '¿El precio incluye flete?',
    a: 'En pedidos desde $5,000 la entrega a domicilio u obra es sin costo dentro de nuestra zona de cobertura. En pedidos menores te cotizamos el flete.',
  },
  {
    q: '¿Facturan?',
    a: 'Sí. Indica que requieres factura al pedir tu cotización.',
  },
  {
    q: '¿Me ayudan a calcular piezas?',
    a: 'Sí. Usa el cotizador de esta página o mándanos tus m² por WhatsApp y te ayudamos a estimar piezas.',
  },
  {
    q: '¿El precio es fijo?',
    a: 'Son precios netos de nuestra lista 2026. Pueden cambiar por disponibilidad o variaciones de materia prima; al cotizar te confirmamos el precio vigente.',
  },
]

/**
 * Fotos de la página. Para usar las fotos reales del equipo OA LOSAS,
 * sube cada foto como JPG/PNG y reemplaza la URL correspondiente.
 */
export const IMAGES = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/d8f91de8-1256-4cf1-a0f5-6a03ab1a4aad.jpg',
  ligero: 'https://cdn.magicpatterns.com/patterns/generated-images/f5da3e6f-f6c8-40a6-837c-c894304f3e8e.jpg',
  entrega: 'https://cdn.magicpatterns.com/patterns/generated-images/dd3b23fb-9003-4d85-9a56-305b85d7951b.jpg',
  planos: 'https://cdn.magicpatterns.com/patterns/generated-images/3c6e73f7-65ed-4cc7-be5a-5196f3592de2.jpg',
  almacen: 'https://cdn.magicpatterns.com/patterns/generated-images/4ceed713-0eeb-49c1-8e17-5ef7452d5153.jpg',
}

export const PRICE_DISCLAIMER =
  'Precios netos, lista 2026. Sujetos a cambio sin previo aviso y a disponibilidad. Entrega sin costo en pedidos desde $5,000 dentro de zona de cobertura.'
